import { defineComponent as _defineComponent } from 'vue'
import {
  computed, ref
} from 'vue';
import animationFrameWait from '@/utils/animationFrameWait';


export default /*#__PURE__*/_defineComponent({
  __name: 'BCXAbsoluteTransition',
  props: {
  name: {
    type: String,
    default: 'bcx-transition-fade'
  }
},
  emits: ['start-transition', 'end-transition'],
  setup(__props, { emit }) {

const props = __props;






const el = ref<HTMLElement | null>(null);
const measuredHeightTo = ref(0);
const measuredHeightFrom = ref(0);
const measuredWidth = ref(0);
const shouldSetToHeight = ref(false);

const isSlideAnimation = computed(() => props.name.includes('slide'));

const measureSize = () => {
  const base = el.value;
  if (!base) return;
  const lastChild = base.lastElementChild;
  const firstChild = base.firstElementChild;
  if (!lastChild || !firstChild) return;
  const { height: heightTo } = lastChild.getBoundingClientRect();
  const { height: heightFrom } = firstChild.getBoundingClientRect();
  const { width } = base.getBoundingClientRect();
  measuredHeightTo.value = heightTo;
  measuredHeightFrom.value = heightFrom;
  measuredWidth.value = width;
};

const style = computed(() => {
  if (measuredHeightTo.value) {
    const style: any = {
      '--slide-transition-width': `${measuredWidth.value}px`,
      '--slide-transition-height': `${shouldSetToHeight.value ? measuredHeightTo.value : measuredHeightFrom.value}px`,
    };
    if (!shouldSetToHeight.value) style['transition'] = 'unset';
    return style;
  }
  return undefined;
});

const dontMeasureHeight = ref(false);
let timeoutId = 0;

const onEnter = async () => {
  shouldSetToHeight.value = false;
  measureSize();
  await animationFrameWait();
  shouldSetToHeight.value = true;
  emit('start-transition');
};

const onAfterTransition = async () => {
  emit('end-transition');
  if (dontMeasureHeight.value) return;
  measuredHeightTo.value = 0;
};

const onEnterCancelled = () => {
  dontMeasureHeight.value = true;
  if (timeoutId) window.clearTimeout(timeoutId);
  timeoutId = window.setTimeout(() => {
    measuredHeightTo.value = 0;
  }, 1000);
};


return { __sfc: true,props, emit, el, measuredHeightTo, measuredHeightFrom, measuredWidth, shouldSetToHeight, isSlideAnimation, measureSize, style, dontMeasureHeight, timeoutId, onEnter, onAfterTransition, onEnterCancelled }
}

})